import type React from "react";
import {TablePagination} from "@mui/material";
import type {BaseMuixTableController} from "../controllers/BaseMuixTableController.tsx";
import type {GridRowId} from "@mui/x-data-grid-premium";
import {DEFAULT_PAGE_SIZE_OPTIONS} from "../constants/Pagination.ts";
import {observer} from "mobx-react-lite";

type Props = {
    row_id: GridRowId,
    controller: BaseMuixTableController,
    paddingInlineStart: string
}
export const SubGroupPaginationCell: React.FC<Props> = observer(({row_id, controller, paddingInlineStart}) => {

    return <TablePagination
        component="div"
        size="small"
        className="sub-group-pagination"
        style={{paddingInlineStart: paddingInlineStart}}
        rowsPerPageOptions={DEFAULT_PAGE_SIZE_OPTIONS}
        disabled={controller.getGroupPaginationDisabled(row_id)}
        showFirstButton
        showLastButton
        count={controller.getGroupPageCount(row_id)}
        page={controller.getGroupPage(row_id)}
        rowsPerPage={controller.getGroupPerPage(row_id)}
        onPageChange={(e, page) => {
            controller.updateGroupPage(row_id, page);
        }}
        onRowsPerPageChange={(e) => {
            controller.updateGroupPerPage(row_id, Number(e.target.value));
        }}
    />;
});
